export default function Marquee({ items = [], className = "" }) {
  const doubled = [...items, ...items];
  return (
    <div className={`overflow-hidden py-10 border-y border-[var(--line)] ${className}`} data-testid="editorial-marquee">
      <div className="marquee-track items-center gap-12">
        {doubled.map((it, i) => (
          <div key={i} className="flex items-center gap-12 shrink-0">
            <span className="font-serif italic text-[clamp(2.5rem,6vw,5rem)] leading-none text-[var(--navy)] whitespace-nowrap">
              {it}
            </span>
            <span className="inline-block w-2 h-2 bg-[var(--gold)] shrink-0" aria-hidden />
          </div>
        ))}
      </div>
    </div>
  );
}
